<app-collapsible-section
  [title]="'profile.sections.driversLicense' | transloco"
  [defaultOpen]="hasLicenses() || isEditing"
  [forceOpen]="isEditing">
  <div class="licenses">
    <!-- View Mode -->
    <div *ngIf="!isEditing" class="licenses-display">
      <div *ngIf="hasLicenses()" class="license-chips">
        <span *ngFor="let license of getSelectedLicensesArray()" class="license-chip">
          {{ license }}
        </span>
      </div>
    </div>

    <!-- Edit Mode -->
    <div *ngIf="isEditing" class="licenses-edit">
      <p class="edit-instructions">{{ 'profile.driversLicense.selectLicenses' | transloco }}</p>
      <div class="license-checkboxes">
        <label *ngFor="let license of licenseTypes" class="license-checkbox" [class.selected]="isLicenseSelected(license)">
          <input type="checkbox" [checked]="isLicenseSelected(license)" (change)="toggleLicense(license)" />
          <span class="checkbox-label">{{ license }}</span>
        </label>
      </div>

      <div class="form-actions">
        <app-button type="button" variant="outline" color="secondary" (click)="cancelEditing()">
          {{ 'button.cancel' | transloco }}
        </app-button>
        <app-button type="button" variant="filled" (click)="saveChanges()">
          {{ 'button.save' | transloco }}
        </app-button>
      </div>
    </div>

    <!-- Add/Edit Button -->
    <app-button *ngIf="!isEditing && isAuthenticated" variant="outline" color="secondary" [block]="true" [icon]="true" size="lg" (click)="startEditing()">
      <i class="fas" [ngClass]="hasLicenses() ? 'fa-pencil-alt' : 'fa-plus'"></i>
      {{ hasLicenses() ? ('profile.profileSection.edit' | transloco) : ('profile.profileSection.add' | transloco) }}
    </app-button>
  </div>
</app-collapsible-section>
